import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useSecondaryPanelUI } from '@src/components/SecondaryPanel/context/SecondaryPanelContext';
import { Tag } from 'antd';
import {
  FieldValue,
  SetValueProps,
} from '@src/components/FilterDropDown/FilterDropDown.interfaces';

interface FilterTagItemProps {
  filterKey: string;
  label?: ReactNode | string;
  onClear?: (props: SetValueProps) => void;
  valueType?: 'string' | 'array' | 'boolean' | 'number' | 'null' | 'undefined';
  clearValue?: FieldValue;
}

const FilterTagItem: React.FC<FilterTagItemProps> = ({
  filterKey,
  label = '',
  onClear,
  valueType = 'string',
  clearValue: clearValueProp,
}) => {
  const intl = useIntl();
  const { open } = useSecondaryPanelUI();

  return (
    <div className="gx-flex-row">
      <Tag className="filter-dropdown-filter-content-tag-item">
        <div className="filter-dropdown-filter-content-tag">
          <span
            role="button"
            tabIndex={0}
            onClick={e => {
              e.stopPropagation();
              open();
              const filterInput = document.querySelector(`#${filterKey}`);
              if (filterInput) {
                (filterInput as HTMLElement).focus();
              }
            }}
          >
            {label}
          </span>

          <span
            className="filter-dropdown-filter-content-tag-item-close-icon"
            aria-label={intl.formatMessage({ id: 'filterDropdown.removeTag' })}
            role="button"
            tabIndex={0}
            onClick={e => {
              e.stopPropagation();
              if (onClear) {
                const value =
                  clearValueProp !== undefined
                    ? clearValueProp
                    : valueType === 'string'
                      ? ''
                      : valueType === 'array'
                        ? []
                        : null;
                onClear({
                  key: filterKey,
                  value,
                  valueTranslated: '',
                  ...(clearValueProp !== undefined ? { clearValue: clearValueProp } : {}),
                });
              }
            }}
          >
            <span className="material-icons" aria-hidden="true">
              close
            </span>
          </span>
        </div>
      </Tag>
    </div>
  );
};

export default FilterTagItem;
